import { createContext, useContext, useRef, useState, type ReactNode } from "react";
import { styles } from "../styles";

const ToastContext = createContext<(msg: string) => void>(() => {});

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<string | null>(null);
  const timer = useRef<number | undefined>(undefined);

  const notify = (msg: string) => {
    setToast(msg);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setToast(null), 3200);
  };

  return (
    <ToastContext.Provider value={notify}>
      {children}
      {/* aria-live region announces every toast to assistive tech. */}
      <div aria-live="polite" style={styles.srOnly}>{toast}</div>
      {toast && <div role="status" style={styles.toast}>{toast}</div>}
    </ToastContext.Provider>
  );
}

export function useToast(): (msg: string) => void {
  return useContext(ToastContext);
}
